var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c('vue-simple-spinner',{attrs:{"size":_vm.size,"font-size":_vm.fontSize,"line-fg-color":_vm.lineForegroundColor,"line-bg-color":_vm.lineBackgroundColor,"message":_vm.showMessage ? _vm.$t('components.loading') : ''}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }